import type { components } from '@/api'
import type { Field } from '@/modules/Project/Fields/types'

/**
 * Returns true if and only if the field can have its value updated by some user (not necessariy
 * the current user). Takes into account:
 * - Review status
 * - Whether the field has been marked as ground truth
 * - Whether recalculation is blocked because the field is immutable
 *
 * And any other factors that might affect whether the field can have its value updated.
 */
export const getFieldReadonly = (field: Field): boolean => {
  const IMMUTABLE_STALENESS_REASONS: UnknownStalenessReason[] = [
    'immutable_ground_truth',
    'immutable_reviewed',
    'immutable_field',
  ]
  const recalculationBlockedBecauseImmutable =
    field.staleness.status === 'unknown' &&
    IMMUTABLE_STALENESS_REASONS.includes(field.staleness.reason)

  const isGroundTruth = field.groundTruth

  const hasBeenReviewed = field.reviewStatus === 'approved' || field.reviewStatus === 'rejected'

  return recalculationBlockedBecauseImmutable || isGroundTruth || hasBeenReviewed
}

type UnknownStalenessReason =
  components['schemas']['Projects.ListEntities.FieldStaleness.Unknown']['reason']
